import { useEffect, useState } from "react";

const links = [
  { href: "#problema", label: "Il Problema" },
  { href: "#soluzione", label: "Il Pack" },
  { href: "#fa-per-te", label: "Fa per te" },
  { href: "#recensioni", label: "Recensioni" },
  { href: "#partner", label: "Partner" },
  { href: "#faq", label: "FAQ" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`sticky top-0 z-50 border-b backdrop-blur-xl transition-[box-shadow,background-color] duration-300 ${
        scrolled ? "bg-white/90 border-purple-100 shadow-lg shadow-purple-900/5" : "bg-white/70 border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-2.5">
        <a href="#hero" data-testid="nav-logo" className="flex items-center">
          <img src="/logo.png" alt="MIR-IA" data-testid="nav-logo-img" className="h-8 w-auto" />
        </a>
        <nav className="hidden items-center gap-7 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-sm font-medium text-slate-600 transition-colors hover:text-purple-700"
            >
              {l.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
};
